import React, { useState, useMemo, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import {
  Row, Col, Table, Divider, Space, Tooltip, Button,
} from 'antd';
import { content } from './components/docsEquipmentSupplier/content';
import { TableCell, StatusTag, DownloadEquipement, UploadTemp, Modal } from 'components';
import { ReactComponent as ActionsIcon } from '../../../../../assets/icons/res.svg';
import { isBeneficiary, hasValue, isAuditor } from 'utils';
import { getFullDateTimeWithSeconds } from 'utils/helpers';
import { flattenDocs } from './utils';
import { useSupplierType } from 'hooks/useSupplierType';
import { sendReguests, getRequests, updateRequestStatus } from '../../../../../store/forms/actions';
import { useParams } from 'react-router-dom';
import { TextAreaField } from 'components';
import { updateFormField } from 'store/forms/actions';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import ErrorModal from '../../../../../components/layout/components/errorModal';

const UpdateDocumentsEquipmentSupplier = () => {

  const requests = useSelector(state => state.forms?.equipmentRequests);
  const equipment = useSelector(state => state.forms?.equipment);
  const data = Array.isArray(requests) ? requests : Object.values(requests || {});
  const dispatch = useDispatch();
  const applicationReturned = useSelector(state => state.forms?.carrier?.applicationReturned);
  const user = useSelector(state => state.user);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode ||
    !isBeneficiary(user.groups) ||
    (applicationReturned && activeTaskName !== "task.name.accepted") ||
    activeTaskName === "task.name.temporary_rejected" ||
    activeTaskName === "task.name.application_returned_to_supplier";
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const docs = useSelector(state => state.forms.documents);
  const [latestKey, setLatestKey] = useState("");
  const flatDocs = flattenDocs(data.filter(
    v => v.requestBusinessKey === latestKey));
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType()
  const task = useSelector(state => state.forms.task);
  const [attachments, setAttachments] = useState([]);
  const [equipementError, setEquipementError] = useState(false);
  const checkUniquenessCreate = useSelector(state => state.forms.checkUniquenessCreate);

  const params = useParams();

  useEffect(() => {
    if (equipment?.submittingEquipment === true) {
      setEquipementError(true);
    }
  }, [equipment?.submittingEquipment]);


  useEffect(() => {
    if (!equipementError) setEquipementError(false);
    dispatch(
      updateFormField({
        group: 'equipment',
        key: 'submittingEquipment',
        value: false,
      })
    )
  }, [equipementError])

  useEffect(() => {
    dispatch(getRequests(params.taskId));
  }, []);


  const handleSend = async (taskId, attachments) => {
    try {
      const data = await dispatch(sendReguests(taskId, attachments));
      console.log("equipement success with data", data);
      setAttachments([]);
    } catch (e) {
      console.error('Αποτυχία υποβολής');
    } finally {
      dispatch(getRequests(taskId));
    }
  };


  const toggleExpand = (record) => {
    const key = record.id;
    setExpandedRowKeys(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );

    setCommentsById(prev => (
      prev[key] !== undefined ? prev : { ...prev, [key]: record.comment || '' }
    ));
  };

  const dataSource = useMemo(
    () => (Array.isArray(requests) ? requests : Object.values(requests || {})),
    [requests]
  );


  useEffect(() => {
    if (!Array.isArray(requests)) return;
    setCommentsById(prev => {
      const next = { ...prev };
      for (const r of requests) {
        if (next[r.id] === undefined) next[r.id] = r.comment || '';
      }
      return next;
    });
  }, [requests]);

  // 2) Per-row comment state
  const [commentsById, setCommentsById] = useState({});
  const handleCommentChange = (rowId, value) =>
    setCommentsById(prev => ({ ...prev, [rowId]: value }));

  const handleReject = (record) => {
    const value = commentsById[record.id] ?? '';
    dispatch(updateRequestStatus(params.taskId, 'REJECTED', value));
    // window.location.reload();
  };

  const handleApprove = (record) => {
    const value = commentsById[record.id] ?? '';
    dispatch(updateRequestStatus(params.taskId, 'APPROVED', value));
    //  window.location.reload();
  };

  const isBenef = isBeneficiary(user?.groups);

  // 3) Expanded row content – uses the *record* passed by AntD
  const expandedRowRender = (record) => {
    const files = [
      record.documentForUpdate ? { key: 'update', label: <div><b>Αρχείο Ανανέωσης Εξοπλισμού</b></div>, file: record.documentForUpdate } : [],
      record.documentForDeletion ? { key: 'deletion', label: <div><b>Αρχείο Διαγραφής Εξοπλισμού</b></div>, file: record.documentForDeletion } : [],
    ]
    const value = commentsById[record.id] ?? '';

    return (
      <div style={{ padding: '12px 20px 8px 8px' }}>
        <Row gutter={16} className="updateFileComponentWrapper">
          {files.map(({ key, label, file }) => (
            <Col span={12} key={key}>
              <DownloadEquipement description={label} file={[file]} />
            </Col>
          ))}
          <Col span={24}>
            <TextAreaField
              label={<div><b>Σχόλιο Αξιολογητή</b></div>}
              placeholder="Μήνυμα"
              asterisk={false}
              name={`requestAuditorComment_${record.id}`}
              id={`requestAuditorComment_${record.id}`}
              value={value}
              disabled={isBenef || record.status !== 'PENDING_REVIEW' || isViewMode}
              maxLength={1000}
              onChange={(e) => handleCommentChange(record.id, e.target.value)}
            />
          </Col>
          {isAuditor(user?.groups) &&
            <Col span={24} style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 15 }}>
              <Button
                type="default"
                id={`submit-reject-${record.id}`}
                className="ant-btn-primary reject-btn"
                onClick={() => handleReject(record)}
                disabled={!value?.trim() || record.status !== 'PENDING_REVIEW' || isViewMode}
              >
                Απόρριψη
              </Button>
              <Button
                type="default"
                id={`submit-approve-${record.id}`}
                className="ant-btn-primary submit-btn"
                onClick={() => handleApprove(record)}
                disabled={record.status !== 'PENDING_REVIEW' || isViewMode}
              >
                Έγκριση
              </Button>
            </Col>
          }
        </Row>
      </div>
    );
  }


  const requestsColumns = [
    {
      title: 'Αριθμός αιτήματος (Α/Α)',
      dataIndex: 'id',
      key: 'id',
      id: 'id',
      render: (text, record) => <TableCell id={`id-cell-${record.id}`} text={text} />,
      sorter: { compare: (a, b) => a.id - b.id },
      width: 40,
      // fixed:'left',
    },
    {
      title: 'Status Αιτήματος',
      dataIndex: 'status',
      key: 'status',
      id: 'status',
      render: (text, record) => (
        <StatusTag id={`activeTaskName-cell-${record.status}`} status={text} />
      ),
      width: 80,
    },
    // (optional spacer col — your previous render referenced a non-existent field)
    { title: '', key: 'spacer', width: 20 },
    {
      title: 'Ημ. υποβολής',
      dataIndex: 'createdAt',
      key: 'createdAt',
      id: 'createdAt',
      render: (text, record) => (
        <TableCell id={`submissionDate-cell-${record.createdAt}`} text={getFullDateTimeWithSeconds(text)} />
      ),
      width: 90,
    },
    // {
    //   title: 'Υπεύθυνος Αξιολογητής',
    //   dataIndex: 'evaluator',
    //   key: 'evaluator',
    //   id: 'evaluator',
    //   render: (text, record) => <TableCell id={`id-cell-${record.id}`} text={text} />,
    //   width: 100,
    // },
    {
      title: 'Ημ. Αξιολόγησης',
      dataIndex: 'evaluatedAt',
      key: 'evaluatedAt',
      id: 'evaluatedAt',
      render: (text, record) => (
        <TableCell id={`submissionDate-cell-${record.createdAt}`} text={getFullDateTimeWithSeconds(text)} />
      ),
      width: 80,
    },
    {
      title: '',
      key: 'action',
      align: 'right',
      width: 60,
      render: (_, record) => {
        const key = record.id;
        const isOpen = expandedRowKeys.includes(key);
        return (
          <Space align="end" style={{ width: 'auto', marginRight: '2rem' }}>
            <Tooltip title={isOpen ? 'Κλείσιμο λεπτομερειών' : 'Άνοιγμα λεπτομερειών'}>
              <Button
                shape="circle"
                onClick={() => toggleExpand(record)}
                size="large"
                id='expand-row'
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, width: 28, height: 28 }}
              >
                <ActionsIcon
                  style={{
                    width: 16,
                    display: 'block',
                    transition: 'transform 0.3s ease',
                    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                    transformOrigin: 'center',
                  }}
                />
              </Button>
            </Tooltip>
          </Space>
        );
      },
    },
  ];



  return (
    <>
      <ErrorModal
        isVisible={equipementError}
        setVisible={setEquipementError}
        error={equipment?.error}
      />

      <div className="stepper-warning-message">
        Μπορείτε να υποβάλετε αίτημα ανανέωσης εξοπλισμού ανεβάζοντας Αρχείο Ανανέωσης Εξοπλισμού ή/και Αρχείο Διαγραφής Εγγραφών Εξοπλισμού.
        Αν υπάρχει αίτημα υπό αξιολόγηση, η υποβολή νέου αιτήματος δεν θα είναι διαθέσιμη.
      </div>
      {(isBeneficiary(user?.groups) && task.taskName === "task.name.accepted") &&
        <Row justify="space-between" align="middle" style={{ marginTop: 40, marginBottom: 40 }}>
          <Col>
            <Row>
              <p className="mt-10 mr-0 color-blue-3 text-bold font-size-24" style={{ margin: 0 }}>
                Ιστορικότητα Αιτημάτων</p>
            </Row>
          </Col>
          <Col>

           {(checkUniquenessCreate?.acceptableDate || checkUniquenessCreate?.acceptableEquipmentUpdate) && <Button type="primary" onClick={() => handleSend(params.taskId, attachments)} disabled={(isEmpty(attachments) || hasValue(requests, 'PENDING_REVIEW'))} className='saveButton'>
              Υποβολή Νέου αίτηματος
            </Button>}

          </Col>
        </Row>
      }
      <div className='documentsWrapper'>
        <div className='documentsContent'>
          {(isBeneficiary(user?.groups) && task.taskName === "task.name.accepted" && (checkUniquenessCreate?.acceptableDate || checkUniquenessCreate?.acceptableEquipmentUpdate)) &&
            <Row gutter={16} className="updateFileComponentWrapper">
              {content().map((item, index) => (
                <Col span={12} >
                  <UploadTemp
                    disabled={(hasValue(requests, 'PENDING_REVIEW')) || viewMode}
                    key={index}
                    item={item}
                    uploadedFiles={attachments?.filter(f => f.type === item.fileCode)}
                    setUploadedFiles={(newFilesOfThisType) => {
                      setAttachments(prev => {
                        // Remove old files of same type and append new ones
                        const filtered = prev.filter(f => f.type !== item.fileCode);
                        return [...filtered, ...newFilesOfThisType];
                      });
                    }}
                  />
                </Col>
              ))}
            </Row>
          }
          <Divider className="custom-divider" />
          {(isAuditor(user?.groups) && task.taskName === "task.name.accepted") &&
            <p className="mt-10 mr-0 color-blue-3 text-bold font-size-24">
              Ιστορικότητα Αιτημάτων
            </p>
          }
          <Table
            dataSource={dataSource}
            columns={requestsColumns}
            className="results-table"
            rowKey="id"
            expandable={{
              expandedRowRender,
              expandedRowKeys,
              onExpandedRowsChange: setExpandedRowKeys,
              expandIcon: () => null,
              expandRowByClick: false,
              fixed: false,
              showExpandColumn: false
            }}
          />
        </div>
      </div>
    </>
  );
};

export default UpdateDocumentsEquipmentSupplier;
